/** Strings owned by `src/manage/pilots/` — "Beheer › Pilots" (PLAN-FASE2.md
 * WP-07): the platform-wide pilot overview, reusing WP-04's pilot statuses. */
export const managePilots = {
  page: {
    title: 'Pilots',
    lead: 'Every pilot on the platform, filterable by company and status.',
    filterCompany: 'Company',
    filterStatus: 'Status',
    allCompanies: 'All companies',
    allStatuses: 'All statuses',
    empty: 'No pilots match these filters.',
    rowsLabel: 'the pilots',
    company: 'Company',
    name: 'Name',
    status: 'Status',
    startDate: 'Start date',
    endDate: 'End date',
    departments: 'Departments',
  },
  status: {
    draft: 'Draft',
    baseline: 'Baseline',
    active: 'Active',
    interim_review: 'Interim review',
    final_review: 'Final review',
    completed: 'Completed',
    scaled: 'Scaled',
  },
} as const;
